import React, { useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Select } from 'grommet';

import { getPropertyList, getPropertyFile } from '../../../../api';
import { PageWrapper, MigrationActions, Breadcrumbs, Pagination, Badge } from '../../../../components';
import { TableHeader, TableMessages, TableWrap, TableRow, TableCols, TableActionsCol } from '../../../../components/listing';

import { useOpenLayer, useFetchListing } from '../../../../hooks';

import { layers, pagination, messageDictionary, propertyUsageType, propertyStatus } from '../../../../constants';

const SearchResult = () => {
  const { migrationId } = useParams();
  const [searchTerm, setSearchTerm] = useState('');
  const [usageTypeFilter, setUsageTypeFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  const { open } = useOpenLayer();

  const filters = useMemo(() => ({
    ...(searchTerm && { search: searchTerm }),
    ...(usageTypeFilter && { usage_type_id: usageTypeFilter }),
    ...(statusFilter && { status_id: statusFilter })
  }), [searchTerm, usageTypeFilter, statusFilter]);

  const {
    loading,
    list,
    requestError,
    page,

    onNavigate,
  } = useFetchListing({
    migrationId,
    get: getPropertyList,
    filters
  });

  return (
    <PageWrapper>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        width: '100%'
      }}>
        <MigrationActions />
        <Breadcrumbs />
      </div>

      <TableWrap>
        <TableHeader
          title='Imóveis'
          totalItens={list.total}

          download={{
            fileName: 'imoveis.csv',
            resource: getPropertyFile,
          }}
        />

        <div className='table-filter'>
          <input
            type='search'
            placeholder='Buscar por código ou referência...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className='table-filter__input'
          />

          <Select
            options={[{ name: 'Todos os tipos', id: '' }, ...propertyUsageType]}
            value={usageTypeFilter?.toString() ?? ''}
            labelKey='name'
            valueKey={{
              key: 'id',
              reduce: true,
            }}
            emptySearchMessage='Selecione um tipo'
            onChange={({ target }) => setUsageTypeFilter(target.value)}
            className='table-filter__select'
          />

          <Select
            options={[{ name: 'Todos os status', id: '' }, ...propertyStatus]}
            value={statusFilter?.toString() ?? ''}
            labelKey='name'
            valueKey={{
              key: 'id',
              reduce: true,
            }}
            emptySearchMessage='Selecione um status'
            onChange={({ target }) => setStatusFilter(target.value)}
            className='table-filter__select'
          />
        </div>

        {requestError && (
          <TableMessages message={messageDictionary.requestFail} />
        )}

        {loading && !requestError && (
          <TableMessages message={messageDictionary.waitingResponseRequest} />
        )}

        {!loading && !requestError && list.total <= 0 && (<TableMessages />)}

        {!loading && !requestError && list.data.map((row, index) => (
          <TableRow key={index}>
            <TableCols
              columns={[
                { value: row.property_secondary_reference, textSize: 'medium' },
                { value: <Badge text={row.status} /> },
                { value: row.usage_type },
                { value: row.usage },
                { value: row.location_street_address },
                { value: row.location_neighborhood },
                { value: row.location_city },
                { value: row.location_state },
                { value: row.bedroom ? `${row.bedroom} dorm(s)` : null },
                { value: row.garages ? `${row.garages} vaga(s)` : null },
              ]}
            />

            <TableActionsCol
              actions={[
                {
                  label: 'detalhes',
                  action: () => open({ entityIdentifier: row._id, layer: layers.detail }),
                }
              ]}
            />
          </TableRow>
        ))}
      </TableWrap>

      <Pagination
        totalOfRows={list.total}
        page={page}
        perPage={pagination.limit}
        onNavigate={onNavigate}
      />
    </PageWrapper>
  )
}

export default SearchResult;
